"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIERED = exports.FLAT = void 0;
var FLAT = 'FLAT';
exports.FLAT = FLAT;
var TIERED = 'TIERED';
exports.TIERED = TIERED;